module.exports = __webpack_public_path__ + "img/map-outlined.2230412a.svg";